import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  Container,
  Breadcrumb,
  BreadcrumbItem,
  Row,
  Col,
  Label,
  Input,
  FormGroup,
  Form,
  Button,
} from "reactstrap";
import { NavLink } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { directUrl, homePageUrl } from "../../../helpers/Constants";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { requestApi } from '../../../request-api'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Triangle } from 'react-loader-spinner'
import { clone, cloneDeep } from "lodash";
import { act } from "react-dom/test-utils";


function ComplainceOfficer() {
    let navigate = useNavigate();
  let [calendarValue, setCalenderValue] = useState(new Date());
  let [showCalender, setShowCalender] = useState(false);
  let [selectedDate, setSelectedDate] = useState("");
  let [user, setUser] = useState('');
  let [name, setName] = useState('');
  let [contactNumber, setContactNumber] = useState('');
  let [adhaarNumber, setAdhaarNumber] = useState('');
  let [companyName, setCompanyName] = useState("");
  let [branch, setBranch] = useState([]);
  let [officeAddress, setOfficeAddress] = useState('');
  let [companyList, setCompanyList] = useState([]);
  let [success, setSuccess] = useState(true);
  let [companyCount, setCompanyCount] = useState(1);
  let [company, setCompany] = useState('');

  let [branchId,setBranchId] = useState([]);
  let [arrCompany,setArrCompany] = useState([]);
  let [value,setValue] = useState([]);
  let [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState('');
  let [formErrors, setFormErrors] = useState({});
  let [isSubmit, setIsSubmit] = useState(false);
  let [optionData, setOptionData] = useState([]);
  let [state, setState] = useState([]);
  let [selected, setSelected] = useState([]);
  let [oldBranchId, setOldBranchId] = useState([]);
  let [demo, setDemo] = useState([]);
  let string =''
  let values =[]
  let branchData=[];
 


  useEffect(() => {
    getAllCompany()
    // clean -up
    setState({
      searchField: null,
      values: []
    })
  
  }, [success]);

  const successToast = (message) => toast.success(message, {
    position: "bottom-right"
});

const errorToast = (error) => toast.error(error, {
    position: "bottom-right"
});

  useEffect(() => {
    setSelectedDate(
      `${calendarValue.getDate()}/${
        calendarValue.getMonth() + 1
      }/${calendarValue.getFullYear()}`
    );
  }, [calendarValue]);


const options = optionData;

 

  const handleChangeSelect = (e,i) => {
    let newOpts = e;
    let newIndex = i;
     string = state.searchField;  
    
    let leng = e.length -1
    if (e[leng] && e[leng].value === "all") {
      let filteredOptions = clone(options);
     
      filteredOptions = filteredOptions.filter(
        (filteredOption) =>        
          !newOpts.includes(filteredOption)
      );
     
      string = null;
      newOpts = newOpts
        .concat(filteredOptions)
        .filter((newOpt) => newOpt.value !== "all");
    }
    else if(e.length === 0)
    {
      demo[newIndex] =[]
    }
       setState({
          searchField: string,
          values: newOpts,
       });
       let  test = newOpts      
      
       if(demo[newIndex] == undefined)
       {
        console.log("undefined")  
          demo.push(test)
       }
       else{
        if(demo[newIndex].length ==0)
        {
          test.map((t)=>{
            demo[newIndex].push(t)
          })          
        }else{
            let data=   demo[newIndex].filter(
              (fill) =>        
                !e.includes(fill)
            ); 
            if(data.length == 0)
            {
                demo[newIndex] = []
                test.map((t)=>{
                  demo[newIndex].push(t)
                })  
            }
            else{
                for(let k =0;k<demo[newIndex].length;k++)
                {
                    if(demo[newIndex][k].value == data[0].value)
                    {
                      demo[newIndex].splice(k,1);
                    }
                }
            }
        }
       }

       demo.map((d)=>{
        d.map((v)=>{
          values.push(v.value)
        })
       })
        console.log("value is",demo)
      
       console.log("branchId", values);
       setBranchId([{ branch: values }]);
       
  };

  const onInputChange = (string, {action}) => {
      if (action === "input-change") {
      setState({
        searchField: string
      });
    }
  };
  const filterOption = ( options , string) => {
    if (options.value === "all") {
      return true;
    } else if (string) {
      return options.label.includes(string) || options.value.toString().includes(string);
    } else {
      return true;
    }
  };

  const getAllCompany = async () => {  
    
     requestApi('/auditor/company/getCompanyForCompliance',{
        method:'get',       
      }).then((data)=>{
        setCompanyList(data.data)
        companyList.map((item)=>{console.log("list of company",item.company_name)})
      }).catch((error)=>{
        errorToast(error.message)
      })
    
  };
 
  const formValidation = (values) => {
    console.log("startDate",startDate)
    const errors = {};
    const mobRegex = /^(\+\d{1,3}[- ]?)?\d{10}$/;
    const aadharRegex =
      /(^[0-9]{4}[0-9]{4}[0-9]{4}$)|(^[0-9]{4}\s[0-9]{4}\s[0-9]{4}$)|(^[0-9]{4}-[0-9]{4}-[0-9]{4}$)/;

   
    if (name == '') {
      errors.username = "Name is required";
    }
    if (startDate == '') {
      errors.startdate = "Date is required";
    }
    
    
    if (contactNumber == '') {
      errors.number = "Number is required";
    } else if (!mobRegex.test(contactNumber)) {
      errors.number = "Invalid Number";
    }
    if (adhaarNumber == '') {
      errors.aadharnumber = "Number is required";
    } else if (!aadharRegex.test(adhaarNumber)) {
      errors.aadharnumber = "Invalid Number";
    }
    if(branchId.length == 0){
      errors.branch = "Branch is required";
    }else if (
      !company||
      company == "Select Branch"
    ) {
      errors.company = "Branch is required";
    }
    if (company == '') {
      errors.company = "Company Name is required";
    } else if (
      !company||
      company == "Select Company"
    ) {
      errors.company = "Company Name is required";
    }
    if (state.length == 0) {
      errors.branch = "Branch Name is required";
    }
    if (officeAddress == '') {
      errors.officeadd = "Office Address is required";
    }


    return errors;
  };

  const handleSubmit = async (e) => {
   
    e.preventDefault();
    setIsSubmit(true);
    const validate = await formValidation()
    setFormErrors(validate);
    if (Object.keys(validate).length == 0) {
      registerComplianceOfficer();
     
    }
    
    
  };

  const registerComplianceOfficer = async () => {
    
      setLoading(true)
        console.debug('sending code',branchData)
     requestApi('/auditor/compliance/register',{
      method:'post',
      body: JSON.stringify(       
      { 
        name:name,
      phone_number:contactNumber,
      role_id:3,
      aadhaar_number:adhaarNumber,
      DOJ:startDate,
      office_address:officeAddress,
      client_list:branchId
    } )
    }).then((data)=>{
      setLoading(false)
      
      if (data.statusCode == 403) {
        errorToast(data.message)
      }
      if(data.statusCode == 200){
        successToast('Successfully created compliancer officer')
        navigate(`${directUrl}auditor/user-profile`)
      }
      
    }).catch(error=>{
      setLoading(false)
      errorToast(error.message)
    })
  }

  const handleCompany =async(e,i) =>{  
    console.debug('sending code')
    setCompany(e)
    await requestApi('/auditor/branch/getBranchCompliaceNull',{
      method:'post',
      body: JSON.stringify(     
      { 
        company_name:e,
    } )
    }).then((data)=>{
      // setBranch(data.data)      
        let dataoptions =[]
      data.data.forEach(element => {
        dataoptions.push({ value: element.branch_id, label: element.branch_id });
      });
      if(dataoptions.length > 0)
        {
          dataoptions.push({ value: 'all', label: 'Select all' })
        }
      setOptionData(dataoptions);
    })
}


  const [formValues, setFormValues] = useState([{ name: "" }]);

  let addFormFields = () => {  
      
    setFormValues([...formValues, { name: "" }]);    
  };

  let removeFormFields = (i) => {
    let newFormValues = [...formValues];
    newFormValues.splice(i, 1);
    setFormValues(newFormValues);
  };

  return (
    <section className="lyt-section">
      {loading ? (
        <div className="loader-container">
          <div className="spinner"></div>
        </div>
      ) : null}

      <Container fluid className="typ-container">
        <Breadcrumb className="bs-breadcrumb">
          <BreadcrumbItem>
            <NavLink to={`${directUrl}auditor/dashboard`}>Home</NavLink>
          </BreadcrumbItem>
          <BreadcrumbItem>
            <NavLink to={`${directUrl}auditor/user-profile`}>
              User Profile
            </NavLink>
          </BreadcrumbItem>
          <BreadcrumbItem active>Compliance Officer</BreadcrumbItem>
        </Breadcrumb>
        <div className="bs-card typ-padding26">
          <Row>
            <Col xs={12} sm={12} md={12} lg={12} xl={12}>
              <Form className="bs-form">
                <Row className="bb-row">
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <FormGroup>
                      <Label
                        for="examplePassword"
                        className="mr-sm-2 cstm-label"
                      >
                        Type of User
                      </Label>
                      <Input
                        type="text"
                        name="text"
                        className="cstm-input"
                        id="exampleselect"
                        onChange={(e) => {
                          setUser(e.target.value);
                        }}
                        value={'Compliance Officer'}
                        disabled
                      >
                      </Input>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <FormGroup>
                      {' '}
                      <Label for="exampleEmail" className="mr-sm-2 cstm-label">
                        Name<span style={{color:'red'}}>*</span>
                      </Label>
                      <Input
                        type="text"
                        name="name"
                        id="exampleEmail"
                        className="cstm-input"
                        placeholder="Enter Your Name"
                        onChange={(e) => {
                          setName(e.target.value);
                        }}
                      />
                      <p className="error-message">{formErrors.username}</p>
                    </FormGroup>
                  </Col>
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <FormGroup>
                      <Label for="examplecid" className="mr-sm-2 cstm-label">
                        Contact Number<span style={{color:'red'}}>*</span>
                      </Label>
                      <Input
                        type="text"
                        name="text"
                        id="examplecid"
                        className="cstm-input"
                        placeholder="Enter Contact Number"
                        onChange={(e) => {
                          setContactNumber(e.target.value);
                        }}
                      />
                      <p className="error-message">{formErrors.number}</p>
                    </FormGroup>
                  </Col>
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <FormGroup>
                      <Label for="examplegst" className="mr-sm-2 cstm-label">
                        Aadhaar Number<span style={{color:'red'}}>*</span>
                      </Label>
                      <Input
                        type="text"
                        name="name"
                        id="examplegst"
                        className="cstm-input"
                        placeholder="Enter Aadhaar Number"
                        onChange={(e) => {
                          setAdhaarNumber(e.target.value);
                        }}
                      />
                      <p className="error-message">{formErrors.aadharnumber}</p>
                    </FormGroup>
                  </Col>
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <FormGroup>
                      <Label
                        for="examplePassword"
                        className="mr-sm-2 cstm-label"
                      >
                        Date of Joining<span style={{color:'red'}}>*</span>
                      </Label>
                      <div className="calender-area">
                        <DatePicker
                          
                          selected={startDate}
                          dateFormat={'yyyy-MM-dd'}
                          maxDate={new Date()}
                          onChange={(date) => setStartDate(date)}
                          placeholderText="Enter Date of Joining"
                        />
                      </div>
                      <p className="error-message">{formErrors.startdate}</p>
                    </FormGroup>
                  </Col>
                </Row>
                {formValues.map((element, index) => (
                  <div key={index}>
                    <Row className="repeat-row">
                      <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                        <FormGroup>
                          <Label
                            for="examplePassword"
                            className="mr-sm-2 cstm-label"
                          >
                            Company<span style={{color:'red'}}>*</span>
                          </Label>
                          <Input
                            className="typ-select"
                            type="select"
                            // onChange={handleChangeSelect()}
                            name="company_name"
                          
                            onChange={(e) => {
                              console.log('compnay', e.target.value);
                              handleCompany(e.target.value, index);
                            }}
                          >
                            {' '}
                            <option selected disabled>
                              Select Company
                            </option>
                            {companyList.map((item) => (
                              <option>{item.company_name}</option>
                            ))}
                          </Input>
                          <p className="error-message">{formErrors.company}</p>
                        </FormGroup>
                      </Col>
                      <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                        <FormGroup>
                          <Label
                            for="examplePassword"
                            className="mr-sm-2 cstm-label"
                          >
                            Branch<span style={{color:'red'}}>*</span>
                          </Label>
                          <Select
                            id={index}
                            className="custom-multi-select"
                            options={options}
                            isMulti
                            filterOption={filterOption}
                            onInputChange={onInputChange}
                            // onChange={(e)=>console.log()}
                            // clearable={false}
                            onChange={(e) => {
                              console.log('multi ', e);
                              handleChangeSelect(e, index);
                            }}
                            value={demo ? demo[index] : [] }
                            // selected={state.values.length > 0 ? state.values : [] }
                          >
                            <options>{demo? demo[index] : []}</options>
                          </Select>
                          <p className="error-message">{formErrors.branch}</p>
                        </FormGroup>
                      </Col>
                    </Row>
                    {index ? (
                      <div className="button-section">
                        <button
                          type="button"
                          className="bs-btn typ-link remove"
                          onClick={() => removeFormFields(index)}
                        >
                          <span class="icon icon-close"></span> Remove
                        </button>
                      </div>
                    ) : null}
                  </div>
                ))}
                <Row>
                  <div className="button-section">
                    <button
                      className="bs-btn typ-link add"
                      type="button"
                      onClick={() => addFormFields()}
                    >
                      <span class="icon icon-plus-bg"></span> Add more company
                    </button>
                  </div>
                </Row>

                <Row>
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <FormGroup>
                      <Label for="exampleText" className="cstm-label">
                        Office Address<span style={{color:'red'}}>*</span>
                      </Label>
                      <Input
                        type="textarea"
                        name="text"
                        className="cstm-input"
                        rows="5"
                        id="exampleText"
                        placeholder="Enter Office Address"
                        onChange={(e) => {
                          setOfficeAddress(e.target.value);
                        }}
                      />
                      <p className="error-message">{formErrors.officeadd}</p>
                    </FormGroup>
                  </Col>
                </Row>
                <Row>
                  <Col xs={12} sm={12} md={5} lg={5} xl={5}>
                    <button
                      className="bs-btn btn-submit"
                      onClick={(e) => {
                        handleSubmit(e);
                      }}
                      type="button"
                    >
                      SUBMIT
                    </button>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </div>
        <ToastContainer />
      </Container>
    </section>
  );
}

export default ComplainceOfficer;
